import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { AppInput } from '@eruvaka/web-pondlogs-base';
import { useTranslation } from '@eruvaka/web-pondlogs-i18n';
export const DeletePondDialog = memo((props) => {
    const { open, pond, onClose, onConfirm } = props;
    const { t } = useTranslation('ponds');
    const [confirmText, setConfirmText] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);
    const [error, setError] = useState(null);
    // Use hardcoded expected text with proper fallback
    const expectedText = t('delete.confirmText');
    const isConfirmValid = confirmText.toLowerCase().trim() === expectedText.toLowerCase();
    const handleClose = () => {
        setConfirmText('');
        setError(null);
        onClose();
    };
    const handleConfirm = async () => {
        if (!pond || !isConfirmValid)
            return;
        setIsDeleting(true);
        setError(null);
        try {
            await onConfirm(pond.id, confirmText.trim());
            handleClose();
        }
        catch (err) {
            const errCode = err.errorCode ?? '';
            setError(errCode === 'FORBIDDEN' ? 'errors.permissionDenied' : 'errors.deleteFailed');
        }
        finally {
            setIsDeleting(false);
        }
    };
    return (_jsxs(Dialog, { open: open, onClose: handleClose, maxWidth: "sm", fullWidth: true, children: [_jsx(DialogTitle, { sx: { textTransform: 'none' }, children: t('delete.title') }), _jsxs(DialogContent, { children: [_jsxs(Typography, { sx: { mb: 2 }, children: [t('delete.confirmPrefix'), ' ', _jsx(Typography, { component: "span", fontWeight: 700, children: pond?.name ?? '' }), '?'] }), _jsx(Alert, { severity: "warning", sx: { mb: 3 }, children: t('delete.warningMessage') }), _jsxs(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 1 }, children: [t('delete.typeToConfirmPrefix'), ' ', _jsxs(Typography, { component: "span", variant: "body2", fontWeight: 700, children: ["\u201C", expectedText, "\u201D"] }), ':'] }), _jsx(AppInput, { placeholder: expectedText, value: confirmText, onChange: (e) => setConfirmText(e.target.value), autoFocus: true }), error && (_jsx(Alert, { severity: "error", sx: { mt: 2 }, children: t(error) }))] }), _jsxs(DialogActions, { children: [_jsx(Button, { variant: "outlined", onClick: handleClose, disabled: isDeleting, children: t('delete.cancel') }), _jsx(Button, { variant: "contained", color: "error", onClick: handleConfirm, disabled: !isConfirmValid || isDeleting, startIcon: isDeleting ? _jsx(CircularProgress, { size: 14, color: "inherit" }) : undefined, children: isDeleting ? t('delete.deleting') : t('delete.deleteForever') })] })] }));
});
